import { connectedStore } from '../../store';
import view from '../../view';
import getBlockConstraint from '../selectors/block-constraint';
import isNumeric from '../../../utils/is-numeric';

const canBeInsertedInto = (parent) => (blockId) => {
  const store = connectedStore.get();
  const state = store.getState();

  const liveDocument = view.accessors.getLiveDocument();
  const context = parent || liveDocument;

  const constraint = getBlockConstraint(state, blockId);

  if (!constraint) return false;

  if (!isNumeric(constraint.maxCount)) return true;

  return context.querySelectorAll(constraint.element).length < constraint.maxCount;
};

export default canBeInsertedInto;
